import { render, staticRenderFns } from "./UniversalLogin.vue?vue&type=template&id=2ce0a70e&"
import script from "./UniversalLogin.vue?vue&type=script&lang=js&"
export * from "./UniversalLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UniversalLogin.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce0a70e')) {
      api.createRecord('2ce0a70e', component.options)
    } else {
      api.reload('2ce0a70e', component.options)
    }
    module.hot.accept("./UniversalLogin.vue?vue&type=template&id=2ce0a70e&", function () {
      api.rerender('2ce0a70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UniversalLogin.vue"
export default component.exports